/**
 * Best Sellers section — Damle Foods
 * - Prev/next buttons scroll the product track (mobile/tablet carousel)
 * - Progressive-enhancement add-to-cart: tries a fast AJAX add,
 *   falls back to a normal form submit (full page nav to /cart)
 *   if fetch fails for any reason, so it never dead-ends the buyer.
 */
(function () {
  function initTrack(root) {
    var track = root.querySelector('[data-bsp-track]');
    var prev = root.querySelector('[data-bsp-prev]');
    var next = root.querySelector('[data-bsp-next]');
    if (!track || !prev || !next) return;

    function cardStep() {
      var card = track.querySelector('.bsp__card');
      if (!card) return 260;
      return card.getBoundingClientRect().width + 16;
    }

    function updateNavState() {
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();
  }

  function initForms(root) {
    var forms = root.querySelectorAll('[data-bsp-form]');

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var button = form.querySelector('[data-bsp-submit]');
        var label = form.querySelector('[data-bsp-label]');
        if (!button || button.disabled) return;

        event.preventDefault();

        var originalText = label ? label.textContent : '';
        button.disabled = true;
        if (label) label.textContent = 'Adding…';

        var formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            button.classList.add('is-added');
            if (label) label.textContent = 'Added ✓';

            // Let the theme's own cart drawer/notification pick this up
            // if it listens for a standard cart-update signal.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            try {
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:build', { bubbles: true, detail: { source: 'bsp' } })
              );
            } catch (err) {
              /* no-op: theme may not use this event, that's fine */
            }

            setTimeout(function () {
              button.disabled = false;
              button.classList.remove('is-added');
              if (label) label.textContent = originalText;
            }, 1800);
          })
          .catch(function () {
            // Fall back to a normal, non-JS form submission so the
            // add-to-cart action still completes for the shopper.
            form.submit();
          });
      });
    });
  }

  function initSection(root) {
    if (root.dataset.bspInit === 'true') return;
    root.dataset.bspInit = 'true';
    initTrack(root);
    initForms(root);
  }

  document.querySelectorAll('[data-bsp]').forEach(initSection);

  // Re-init when a section is added/re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-bsp]');
    if (root) initSection(root);
  });
})();